import { render, staticRenderFns } from "./CommentFormModal.vue?vue&type=template&id=00c65641&scoped=true&"
import script from "./CommentFormModal.vue?vue&type=script&lang=js&"
export * from "./CommentFormModal.vue?vue&type=script&lang=js&"
import style0 from "./CommentFormModal.vue?vue&type=style&index=0&id=00c65641&lang=scss&scoped=true&"
import style1 from "./CommentFormModal.vue?vue&type=style&index=1&id=00c65641&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c65641",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00c65641')) {
      api.createRecord('00c65641', component.options)
    } else {
      api.reload('00c65641', component.options)
    }
    module.hot.accept("./CommentFormModal.vue?vue&type=template&id=00c65641&scoped=true&", function () {
      api.rerender('00c65641', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/chat/CommentFormModal.vue"
export default component.exports